export const additionalCoachText = `

<div style="background: #eee;margin-top: 21px;padding: 20px;">
<h3>Your account has already been created in Topnotch Athletes(TNA) but is inactive. To activate your account in TNA and connect with this user you need to first create/reset your password. 
</h3>

<a style="
    display: inline-block;
    padding: 11px 26px;
    font-family: 'Source Sans Pro',Helvetica,Arial,sans-serif;
    font-size: 15px;
    color: #ffffff;
    text-decoration: none;
    border-radius: 6px;
    background: #c22b2c
    border: #c22b2c;
" href="${window.location.origin}/reset-password"> Create/Reset Password</a>
<p>Please view ${window.location.origin}/college-recruiting page for college recruiting.</p>
</div>
`;

export const subjectText = (userType, user, coachOf) => {
  if (userType === "athlete")
    return `${user} wants to connect with you in TNA. Activate your account to connect with this user`;
  else if (userType === "clubCoach")
    return `${user} of ${coachOf} wants to connect with you In TNA. Activate your account to connect with this user.`;
  else
    return `${user} of ${coachOf} wants to connect with you In TNA. Activate your account to connect with this user.`;
};
